export const SAVE_PHONE_PAY_SETTING = "SAVE_PHONE_PAY_SETTING"
export const SAVE_PHONE_PAY_SETTING_SUCCESS = " SAVE_PHONE_PAY_SETTING_SUCCESS"


export const DELETE_PHONE_PAY_SETTING_LIST_ID = "DELETE_PHONE_PAY_SETTING_LIST_ID"
export const DELETE_PHONE_PAY_SETTING_LIST_ID_SUCCESS = "DELETE_PHONE_PAY_SETTING_LIST_ID_SUCCESS"

export const GET_PHONE_PAY_SETTING_LIST_ID = "GET_PHONE_PAY_SETTING_LIST_ID"
export const GET_PHONE_PAY_SETTING_LIST_ID_SUCCESS = "GET_PHONE_PAY_SETTING_LIST_ID_SUCCESS"


export const EDIT_PHONE_PAY_SETTING_ID = "EDIT_PHONE_PAY_SETTING_ID"
export const EDIT_PHONE_PAY_SETTING_ID_SUCCESS = "EDIT_PHONE_PAY_SETTING_ID_SUCCESS"


export const UPDATE_PHONE_PAY_SETTING_ID = "UPDATE_PHONE_PAY_SETTING_ID"
export const UPDATE_PHONE_PAY_SETTING_ID_SUCCESS = "UPDATE_PHONE_PAY_SETTING_ID_SUCCESS"

export const PHONE_PAY_SETTING_API_ERROR_ACTION = "PHONE_PAY_SETTING_API_ERROR_ACTION"